exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stop-item[data-v-b3c18b22] {\n  display: inline;\n}\n", ""]);

// exports
